import { FilterOptions } from '../model/filter-options.model';
import { defaultState } from '../task-list-dialog.state';

export function filterIsDefault(opts: FilterOptions): {
    search: boolean;
    filter: boolean;
} {
    const ds = defaultState().filterOpts;
    return {
        search: (opts.keyword ?? '') === (ds.keyword ?? ''),
        filter:
            ((opts.status == null && ds.status == null) ||
                opts.status.important === ds.status.important) &&
            opts.dateRange?.from?.getTime() === ds.dateRange?.from?.getTime() &&
            opts.dateRange?.to?.getTime() === ds.dateRange?.to?.getTime(),
    };
}
